import React from "react";
import { Link } from "../../raw-components/link/link";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { DepositSideMenuLinkBox } from "./boxes/link/deposit-side-menu-link.box";
import { GenericSideMenuLabelBox } from "./boxes/link/generic-side-menu-label.box";
import { ArrowSideMenuLinkIcon } from "./icons/arrow-side-menu-link.icon";
import { SideMenuLinkProps } from "../side-menu-link.interface";

export class DepositSideMenuLink extends OrbitComponent<SideMenuLinkProps> {
    render() {
        const config = this.props.config;
        const href = this.services.location.buildFullUri(config.link);
        return <Link href={decodeURI(encodeURI(href.toString()))} onClick={this.onClick}>
            <DepositSideMenuLinkBox>
                <GenericSideMenuLabelBox>{ this.services.translation.translate(config.text) }</GenericSideMenuLabelBox>
                <ArrowSideMenuLinkIcon />
            </DepositSideMenuLinkBox>
        </Link>;
    }
    onClick = (event: React.MouseEvent) => {
        const config = this.props.config;
        /**
         * TODO: INSTEAD OF CALLING THE GENERAL getLinkAction make a dedicated handler for desposit/cashier, like:
         * this.services.sideMenu.executeDepositLink();
         */
        this.services.sideMenu.getLinkAction(config)(event);
        // run whatever else was passed by props
        if (this.props.onClick) {
            this.props.onClick();
        }
    };

}
